export default {
  QCStandard: {
    category: {
      categoryTree: 'api/QcCategory/categoryTree',
      addCategory: 'api/QcCategory/addCategory',
      updateCategory: 'api/QcCategory/updateCategory',
      delCategory: 'api/QcCategory/delCategory',
      getLvTree: 'api/QcCategory/lvTree',
    },
    standardItem: {
      getList: 'api/QcStandardItem/getList',
      add: 'api/QcStandardItem/add',
      update: 'api/QcStandardItem/update',
      del: 'api/QcStandardItem/del',
      changeStatus: 'api/QcStandardItem/changeStatus',
      downloadTemplate: 'api/QcStandardItem/download/template',
      importData: '/api/QcStandardItem/importData',
    },
    projectStandard: {
      getList: 'api/QcProjectStandard/getList',
      add: 'api/QcProjectStandard/add',
      update: 'api/QcProjectStandard/update',
      del: 'api/QcProjectStandard/del',
      verifyDefaultQc: 'api/QcProjectStandard/verifyDefaultQc'
    }
  }
}
